<template>
    <v-container :fluid="true">
        <v-row>
            <v-col class="mx-auto" cols="8">
                <v-card elevation="3">
                    <v-form v-model="formData.valid" class="mb-3" validate-on="blur" @submit.prevent="updateSettings">
                        <v-card-title id="heading" class="text-start font-weight-bold">Payment Gateways</v-card-title>

                        <v-container>
                            <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                                     density="compact" variant="tonal">
                                <p v-for="error in errors">{{ error }}</p>
                            </v-alert>
                            <v-row>
                                <v-col v-for="gateway in gateways" v-if="!loading && gateways.length" cols="12" sm="6">
                                    <v-switch v-model="formData[gateway.name.toLowerCase()]" :label="gateway.name"
                                              color="primary" density="compact"/>
                                </v-col>
                                <v-progress-circular v-else color="primary" indeterminate/>
                            </v-row>
                        </v-container>

                        <v-card-actions class="px-4 d-flex justify-end">
                            <v-btn color="primary" size="small" type="submit">Save</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const errors = ref([]);
const gateways = ref([]);
const loading = ref(false);
const {showSnackbar} = useSnackbarStore();
const formData = reactive({
    valid: false,
})

onMounted(() => {
    fetchPmGateways();
})
const fetchPmGateways = () => {
    loading.value = true;
    send('get', `admin/payment-gateways`)
        .then((response) => {
            gateways.value = response.data.data;
            gateways.value.map((gateway) => {
                formData[gateway.name.toLowerCase()] = gateway.status ? true : false;
            })
            // showSnackbar(response.data.message);
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        }).finally(() => loading.value = false);
}
const updateSettings = () => {
    if (formData.valid) {
        errors.value = [];
        send('put', `admin/payment-gateways/status`, formData)
            .then((response) => {
                showSnackbar(response.data.message);
            })
            .catch(function (errorResponse) {
                if (errorResponse.response.data.errors) {
                    let validationErrors = errorResponse.response.data.errors;
                    Object.keys(validationErrors).forEach((key) => {
                        errors.value.push(validationErrors[key][0]);
                    });
                } else if (errorResponse.response.data.message) {
                    errors.value.push(errorResponse.response.data.message);
                }
                showSnackbar('Something went wrong', 'error');
                document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
            });
    }
}
</script>
